export const getUserSourcingListColumns = (settings) =>
  settings.getIn(['listcolumnssourcing', 'sourcing']);

export const getUserListColumns = (settings, columnsKey) =>
  settings.getIn(['listcolumns', columnsKey]);
